import React from 'react';

interface AddItemCTAProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

/**
 * AddItemCTA — black pill button used for all "+ Add …" actions
 * (Add Answer, Add more, Add Pair, Add Blank, Add Item).
 */
export default function AddItemCTA({
  label,
  onClick,
  disabled,
  className = '',
}: AddItemCTAProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 self-center mx-auto h-[41px] min-w-[180px] px-6 rounded-full border-0 bg-grey-900 text-white font-sans font-bold text-[15px] leading-6 cursor-pointer transition-all hover:brightness-110 active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed dark:bg-white dark:text-grey-900 ${className}`}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
      {label}
    </button>
  );
}
